import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import MonitorService from '../../../controllers/MonitorService';
import { selectionTypes } from '../../utils/consts';
import WidgetSettings from './widgetsettings';

class OutgoingCallsSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSettings: false,
            totalCalls: 0,
            answeredCalls: 0,
            missedCalls: 0,
            groupId: -1,
            groupName: ""
        };

        this.updateState = this.updateState.bind(this);
        this.setGroup = this.setGroup.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
    }

    updateState(callssummary) {
        var data = JSON.parse(callssummary.body);
        this.setState({
            totalCalls: data.totalCalls,
            answeredCalls: data.answeredCalls,
            missedCalls: data.missedCalls
        });
    }

    componentDidMount() {
        let groupId = parseInt(localStorage.getItem(`outgoingcallssummary_groupId_${this.props.userId}`) || -1);
        let groupName = localStorage.getItem(`outgoingcallssummary_groupName_${this.props.userId}`) || this.props.t("all2");
        this.setState({
            groupId: groupId,
            groupName: groupName
        });
        
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/outgoingcallssummary_${this.props.userId}/`, this.updateState, { id: `outgoingcallssummary_${this.props.userId}` });

            MonitorService.stompClient.send("/app/subscribe/outgoingcallssummary", {}, JSON.stringify({
                token: this.props.token,
                widgetId: this.props.userId,
                groupId: groupId
            }));
        }

    }

    componentWillUnmount() {
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send(`/user/topic/outgoingcallssummary_${this.props.userId}/`, {}, JSON.stringify({ token: this.props.token }));
            MonitorService.stompClient.unsubscribe(`outgoingcallssummary_${this.props.userId}`);
        }
    }

    setGroup(groupId, groupName) {

        this.setState({
            groupId: groupId,
            groupName: groupName,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`outgoingcallssummary_groupId_${this.props.userId}`, groupId);
        localStorage.setItem(`outgoingcallssummary_groupName_${this.props.userId}`, groupName);
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/outgoingcallssummary", {}, JSON.stringify({
                token: this.props.token,
                widgetId: this.props.userId,
                groupId: groupId
            }));
        }

    };

    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    render() {
        return (
            <div className='position-relative'>
                <div className={"card card-flush overflow-hidden widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                    <div className="card-header drag-handle">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-up-right")} /> {this.props.t("outgoingcalls")} - {this.state.groupName}</span>
                        </h3>
                        <div className="card-toolbar" style={{ zIndex: 1000 }}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("config")}
                                </Tooltip>}>
                                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                    <FontAwesomeIcon icon={duotone("grid-2")} />
                                </button>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                        <Row>
                            <Col lg={4} md={4} sm={4} xs={4}>
                                <div className="fs-3hx fw-bold text-gray-800 statsnumber">{this.state.totalCalls}</div>
                                <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("total")}</div>
                            </Col>
                            <Col lg={4} md={4} sm={4} xs={4}>
                                <div className="fs-3hx fw-bold text-success statsnumber">{this.state.answeredCalls}</div>
                                <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("attended")}</div>
                            </Col>
                            <Col lg={4} md={4} sm={4} xs={4}>
                                <div className="fs-3hx fw-bold text-danger statsnumber">{this.state.missedCalls}</div>
                                <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("missed")}</div>
                            </Col>
                        </Row>
                    </div>



                </div>
                <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroup={this.setGroup} groupId={this.state.groupId} groupName={this.state.groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(OutgoingCallsSummary);